import { FilterMatchMode } from "primereact/api"

export class Contingencia {
    model = {
        id: { value: null, export: false },
        idp: { value: null, export: false },
        detalle: {
            value: '', export: true, header: 'Detalle', required: 'Detalle es requerido', maxLength: 'Máximo 300 caracteres',
            filterPlaceholder: 'Búsqueda', minLength: 'Mínimo 4 caracteres', max: 500, min: 4, filterField: 'detalle',
            table: true, filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS
        },
        responsable: {
            value: null, header: 'Responsable', required: 'Responsable es requerido', table: true
        },
        fecha_inicio: {
            value: null, header: 'Fecha de inicio', required: 'Fecha es requerido', table: true
        },
        fecha_fin: {
            value: null, header: 'Fecha de fin', required: 'Fecha es requerido', table: true
        }
    }
}
